import { useMutation, useQueryClient } from '@tanstack/react-query';
import { correctPcmpProposalPayment } from '../api/pcmpProposals.api';
import { PCMP_CORRECTION_ACTION_COPY } from '../constants/pcmpCorrection.constants';
import type { PcmpCorrectionPaymentPayload } from '../types/pcmpCorrection.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

/** Correct a failed payment's bank or wallet details; repeatable until approved. */
export function useCorrectPcmpProposalPayment(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpCorrectionPaymentPayload) =>
      correctPcmpProposalPayment(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, PCMP_CORRECTION_ACTION_COPY.EDIT.toast, onSuccess),
  });
}
